import React, { useState, useEffect, useRef } from 'react';
import { Send, Paperclip } from 'lucide-react';
import { useChatStore } from '../../../store/chat_store';
import { useAuthStore } from '../../../store/authStore';

const MessageInput = () => {
  const [message, setMessage] = useState('');
  const { sendMessage, sendTyping, sendStopTyping, activeConversation } = useChatStore();
  const { user } = useAuthStore();
  const typingTimeoutRef = useRef(null);

  const handleInputChange = (e) => {
    setMessage(e.target.value);

    if (activeConversation) {
      const currentUserId = user._id || user.id;
      sendTyping(currentUserId, activeConversation.otherUserId);
      
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      
      typingTimeoutRef.current = setTimeout(() => {
        sendStopTyping(currentUserId, activeConversation.otherUserId);
      }, 2000);
    }
  };

  const handleSend = (e) => {
    e.preventDefault();
    if (!message.trim() || !activeConversation) return;

    const currentUserId = user._id || user.id;
    sendMessage(currentUserId, activeConversation.otherUserId, message.trim());
    setMessage('');
    
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
      sendStopTyping(currentUserId, activeConversation.otherUserId);
    }
  };

  useEffect(() => {
    return () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="p-4 bg-white border-t border-gray-200">
      <form onSubmit={handleSend} className="flex items-end space-x-2">
        <button 
          type="button" 
          className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100"
        >
          <Paperclip className="w-5 h-5" />
        </button>
        
        <div className="flex-1 bg-gray-50 rounded-2xl border border-gray-200 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition-all">
          <textarea
            className="w-full bg-transparent px-4 py-3 outline-none resize-none max-h-32 text-sm text-gray-800 placeholder-gray-400"
            placeholder="Type a message..."
            rows={1}
            value={message}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSend(e);
              }
            }}
          />
        </div>

        <button 
          type="submit"
          disabled={!message.trim()}
          className="p-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-sm flex-shrink-0"
        >
          <Send className="w-5 h-5" />
        </button>
      </form>
    </div>
  );
};

export default MessageInput;
